import React from "react";
import type {FunctionComponent} from "react";
import "./DisclosureGroup.scss";
import {FontIcon} from "../FontIcon";

export interface IDisclosureGroup {
  title: string;
  secondaryInfo: string;
}

export const DisclosureGroup: FunctionComponent<IDisclosureGroup> = ({title, secondaryInfo, children}) => {

  return (
    <details className={`disclosureGroup`} open={true} >
      <summary className={`groupHeader`}>
        <FontIcon icon={"icon-angle-right"} />
        <span className={`groupTitle`}>{title}</span>
        <span className={`secondaryInfo`}>{secondaryInfo}</span>
      </summary>
      {children}
    </details>
  );
}

